import store from '@/store/'

export default {
  show (message, color = '') {
    store.dispatch('snackbar/show', {
      message: message,
      color: color
    })
  }
}
